import styled, { css } from 'styled-components'

import { helpers } from 'styles'

export type FocusVisibleProps = {
	isFocusVisible?: boolean
}

/**
 * For full-width buttons, this inset can be shown inside as a focus-visible
 * indicator.
 *
 * Make sure the containing element is `position: relative` to allow positioning
 * to work.
 */
export const FocusVisibleInset = styled.div<FocusVisibleProps>`
	display: ${({ isFocusVisible }) => (isFocusVisible ? 'block' : 'none')};
	position: absolute;
	inset: 2px 4px;
	border-radius: 4px;
	border: 2px solid ${helpers.color.buttonFocus};
	pointer-events: none;

	${({ isFocusVisible }) =>
		isFocusVisible &&
		css`
		&:after {
			content: '';
			position: absolute;
			inset: 1px;
			border-radius: 2px;
			border: 1px solid ${helpers.color.buttonFocus} !important;
			pointer-events: none;
		}
	`}
`

/**
 * Reusable styling for showing an external focus indicator.
 */
export const focusVisibleOutline = css<object>`
	outline: ${(props) => {
		const { isFocusVisible } = props as typeof props & FocusVisibleProps

		return isFocusVisible ? `2px solid ${props.theme.color.buttonFocus}` : 'none'
	}} !important;
	outline-offset: 1px;
	position: relative;

	${(props) =>
		(props as typeof props & FocusVisibleProps).isFocusVisible &&
		css`
		&:after {
			content: '';
			position: absolute;
			inset: 0px;
			border-radius: 2px;
			border: 1px solid ${helpers.color.buttonFocus} !important;
			pointer-events: none;
		}
	`}
`
